import { Box } from "@chakra-ui/react"

// Sizing mirrors the 600x260 "AI BUTTON" comp, so every dimension is that comp's
// measurement scaled to BUTTON_HEIGHT.
export const BUTTON_HEIGHT = 60
const px = n => `${Math.round((n * BUTTON_HEIGHT) / 260)}px`
const BUTTON = { padX: px(100), heart: px(157.5), gap: px(25), wordmark: px(216.5) }

// The one-line variant follows the inline "ASK EMMA" button comp instead: bigger text (cap height
// about a third of the pill), the heart a little smaller, and wider side padding. Each value is
// that comp's measurement as a fraction of its pill height. Its label is live text in Gibson
// (loaded site-wide from globals.css).
const inlinePx = n => `${Math.round(n * BUTTON_HEIGHT)}px`
const INLINE_BUTTON = { padX: inlinePx(0.98), heart: inlinePx(0.57), gap: inlinePx(0.19), fontSize: "27px" }

// Pill fill lifted from the supplied "AI BUTTON" comp (a 45deg navy-to-blue sweep).
const BUTTON_GRADIENT = "linear-gradient(45deg, #100133 13%, #040883 100%)"

// The ASK EMMA pill: heart icon plus wordmark. `inline` sets ASK EMMA as one line of text instead
// of the stacked wordmark. The graphics are outlined vectors from the comp. The button is shrink-to-fit, so the
// site-wide `img { max-width: 100% }` is cyclic here and can collapse the images to 0 - hence
// maxWidth: none.
export default function AskEmmaButton({ inline = false, ...props }) {
    const size = inline ? INLINE_BUTTON : BUTTON
    return (
        <Box
            as="button"
            h={`${BUTTON_HEIGHT}px`}
            px={size.padX}
            borderRadius="full"
            background={BUTTON_GRADIENT}
            boxShadow="0 6px 24px rgba(26,47,110,0.35), 0 2px 8px rgba(0,0,0,0.12)"
            display="flex"
            alignItems="center"
            gap={size.gap}
            cursor="pointer"
            border="1px solid #fff"
            transition="all 0.18s ease"
            aria-label="Ask Emma"
            _hover={{
                boxShadow: "0 8px 28px rgba(26,47,110,0.45)",
                // The supplied hover comp is the same heart scaled 1.114x about
                // its center, so one SVG + a CSS transform reproduces it exactly.
                "& .askEmmaButton__heart": { transform: "scale(1.114)" },
            }}
            {...props}
        >
            <img
                className="askEmmaButton__heart"
                src="/ask-emma-heart.svg"
                alt=""
                style={{
                    width: size.heart,
                    height: "auto",
                    maxWidth: "none",
                    flexShrink: 0,
                    transition: "transform 0.18s ease",
                }}
            />
            {inline ? (
                <Box
                    as="span"
                    fontFamily='"canada-type-gibson", sans-serif'
                    fontWeight={600}
                    fontSize={size.fontSize}
                    lineHeight={1}
                    color="#fff"
                    whiteSpace="nowrap"
                >
                    ASK EMMA
                </Box>
            ) : (
                <img
                    src="/ask-emma-wordmark.svg"
                    alt=""
                    style={{ width: size.wordmark, height: "auto", maxWidth: "none", flexShrink: 0 }}
                />
            )}
        </Box>
    )
}
